import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
export const StyledImage = /*#__PURE__*/_styled("img", process.env.NODE_ENV === "production" ? {
  target: "e1expqve0"
} : {
  target: "e1expqve0",
  label: "StyledImage"
})(process.env.NODE_ENV === "production" ? {
  name: "1f3tddi",
  styles: "inline-size:21px;block-size:18px"
} : {
  name: "1f3tddi",
  styles: "inline-size:21px;block-size:18px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRXFDIiwiZmlsZSI6InN0eWxlcy50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIjtcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEltYWdlID0gc3R5bGVkLmltZ2BcbiAgaW5saW5lLXNpemU6IDIxcHg7XG4gIGJsb2NrLXNpemU6IDE4cHg7XG5gO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});